import React, { useEffect } from 'react';
import Helmet from 'react-helmet';
import { batch, useDispatch, useSelector } from 'react-redux';
import Layout from '../../shared/components/Layout/Layout';
import CalendarCreateLayout from './CalendarCreateLayout';
import { fetchAllProgramTags, fetchParentCalendars } from './ducks/calendarActions';

const CalendarCreate = () => {
  const dispatch = useDispatch();
  const accountCode = useSelector((state) => state.auth.data.currentUser?.accountCode);

  // Build normally loads these, but this page can be opened without visiting Build first.
  useEffect(() => {
    if (!accountCode) return;
    batch(() => {
      dispatch(fetchParentCalendars(accountCode));
      dispatch(fetchAllProgramTags(accountCode));
    });
  }, [accountCode, dispatch]);

  return (
    <Layout fullWidth>
      <Helmet>
        <title>Create Calendar | TeamBuildr</title>
      </Helmet>
      <CalendarCreateLayout />
    </Layout>
  );
};

CalendarCreate.propTypes = {};
export default CalendarCreate;
